export const alertsSystemPermissions = {
    /**
     * Used to manage notifications
     */
    'manage-notifications': {
        group: 'Notifications',
        label: 'Manage Notifications',
    },
};
